import { combineReducers } from 'redux';

import { NormalizedReportItem } from '@modules/reports/basicReports/duck/utils';
import { resetOnLogoutReducer } from '@utils';

import {
  BASIC_REPORTS_ERROR,
  BASIC_REPORTS_RESPONSE,
  CLOSE_SELECT_YOUTH_MODAL,
  OPEN_SELECT_YOUTH_MODAL,
} from './actions';

const reports = (
  state = {},
  {
    type,
    payload,
  }: {
    type: string;
    payload: { reports: NormalizedReportItem[]; guid: string };
  },
) => {
  switch (type) {
    case BASIC_REPORTS_RESPONSE: {
      const { reports, guid } = payload;

      return { ...state, [guid]: reports };
    }
    case BASIC_REPORTS_ERROR: {
      const { guid } = payload;

      return { ...state, [guid]: [] };
    }
    default: {
      return state;
    }
  }
};

const selectYouthModalOpen = (state = false, { type }: { type: string }) => {
  switch (type) {
    case OPEN_SELECT_YOUTH_MODAL: {
      return true;
    }
    case CLOSE_SELECT_YOUTH_MODAL: {
      return false;
    }
    default: {
      return state;
    }
  }
};

const selectedReportCode = (
  state = '',
  { type, payload }: { type: string; payload: string },
) => {
  switch (type) {
    case OPEN_SELECT_YOUTH_MODAL: {
      return payload;
    }
    case CLOSE_SELECT_YOUTH_MODAL: {
      return '';
    }
    default: {
      return state;
    }
  }
};

const reducer = combineReducers({
  reports,
  selectYouthModalOpen,
  selectedReportCode,
});

export default resetOnLogoutReducer(reducer);
